import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { FormattedNumber, FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import Global from '../../../store/global-selectors';

import { buildAgeProps, getAgeColor } from '../../../services/order-helper-service';
import { Multiple } from '../../../components/multiple-text-blurb-for-grid';
import { FulfillmentPlanOrderGridStatus } from '../../../enums/fulfillmentplan-order-grid-status';
import { messages } from './messages';

const OrderAgeColumn = ({ fulfillmentPlanId, isExpanded }) => {
  const salesOrders = useSelector((state) =>
    Global.selectEntitiesSalesOrdersByFulfillmentPlanIds(state, {
      fulfillmentPlanIds: [fulfillmentPlanId],
    }),
  );
  const { orderGridStatus, shipDate } = useSelector((state) => Global.selectEntitiesFulfillmentPlanById(state, { fulfillmentPlanId }));

  const endDateTime = orderGridStatus === FulfillmentPlanOrderGridStatus.Shipped.name && shipDate ? shipDate : undefined;

  const [salesOrder] = salesOrders;
  const { orderDateTime } = salesOrder;

  const ageProps = useMemo(() => buildAgeProps(orderDateTime, endDateTime), [orderDateTime, endDateTime]);

  const component = useMemo(() => {
    const normalizedAgeProps = {
      ...ageProps,
      value: Math.abs(ageProps.value),
    };
    const formattedNumber = <FormattedNumber {...normalizedAgeProps} />;
    return ageProps.value < 0 ? (
      <FormattedMessage
        defaultMessage='in {formattedNumber}'
        description='Order Grid Age Column Future Date'
        id='s9iLbv'
        values={{
          formattedNumber,
        }}
      />
    ) : (
      formattedNumber
    );
  }, [ageProps]);

  if (!isExpanded && salesOrders.length > 1) {
    return <Multiple />;
  }

  return <span style={{ color: getAgeColor(orderDateTime, endDateTime) }}>{component}</span>;
};

OrderAgeColumn.propTypes = {
  fulfillmentPlanId: PropTypes.string.isRequired,
  isExpanded: PropTypes.bool.isRequired,
};

export const Age = {
  getMessageDescriptor: () => messages.age,
  id: 'age',

  render: (data, { isExpanded = false, isFirstOfType = true } = {}) => {
    if (!data?.id || !isFirstOfType) {
      return null;
    }

    return <OrderAgeColumn fulfillmentPlanId={data.id} isExpanded={isExpanded} />;
  },
};
